var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSupportPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 14,
    r: 13.5,
    fill: "white",
    stroke: "#D0103A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.4328 11.2936C15.9939 11.4028 16.5096 11.6767 16.9139 12.0802C17.3181 12.4837 17.5926 12.9984 17.702 13.5585L15.4328 11.2936ZM15.4328 9C16.5986 9.12926 17.6857 9.65033 18.5157 10.4776C19.3456 11.3049 19.869 12.3893 20 13.5527L15.4328 9ZM19.4255 18.1284V19.8486C19.4262 20.0083 19.3934 20.1663 19.3293 20.3126C19.2652 20.459 19.1712 20.5903 19.0533 20.6982C18.9354 20.8062 18.7962 20.8884 18.6446 20.9396C18.4931 20.9907 18.3325 21.0097 18.1731 20.9953C16.4053 20.8036 14.7072 20.2007 13.2153 19.235C11.8272 18.3547 10.6504 17.1801 9.76835 15.7947C8.79745 14.2988 8.19324 12.5957 8.00466 10.8234C7.99031 10.6648 8.00919 10.505 8.0601 10.3541C8.11102 10.2033 8.19285 10.0646 8.30039 9.94703C8.40793 9.82944 8.53883 9.73549 8.68474 9.67117C8.83065 9.60684 8.98838 9.57354 9.1479 9.57339H10.8714C11.1502 9.57065 11.4205 9.66919 11.6319 9.85064C11.8432 10.0321 11.9813 10.2841 12.0203 10.5596C12.0931 11.1101 12.228 11.6506 12.4225 12.1709C12.4998 12.3761 12.5165 12.5991 12.4707 12.8136C12.4249 13.028 12.3184 13.2248 12.164 13.3807L11.4344 14.1089C12.2522 15.5444 13.443 16.733 14.8813 17.5493L15.6109 16.8211C15.7671 16.6669 15.9643 16.5606 16.1791 16.5149C16.394 16.4692 16.6174 16.4859 16.8231 16.563C17.3443 16.7572 17.8858 16.8918 18.4374 16.9644C18.7165 17.0037 18.9713 17.144 19.1535 17.3586C19.3357 17.5732 19.4325 17.8472 19.4255 18.1284Z",
    stroke: "#D0103A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupportPhone);
export default __webpack_public_path__ + "static/media/SupportPhone.b9e4912f2042d773198737c362bd8d11.svg";
export { ForwardRef as ReactComponent };